import React from 'react';

const buffers = [
    ['/', 'milan.el'],
    ['/Publications', 'publications.bib'],
    ['/GitHub', 'projects/'],
    ['/PodBox', 'podbox.app'],
    ['/Archive', 'archive/'],
    ['/About', 'about.org'],
    ['/Contact', 'contact.md']
];

const EditorChrome = ({active = '/'}) => (
    <header className="emacs-chrome" aria-label="Site navigation">
        <div className="emacs-menu" aria-hidden="true">
            <span>File</span><span>Edit</span><span>Options</span><span>Buffers</span><span>Tools</span>
            <button type="button" onClick={() => window.dispatchEvent(new Event('emacs-help'))}>Help</button>
        </div>
        <nav className="buffer-tabs">
            {buffers.map(([path, label]) => (
                <a className={active === path ? 'active' : ''} href={path} key={path}>{label}</a>
            ))}
        </nav>
    </header>
);

export default EditorChrome;
